import { createAsyncThunk } from "@reduxjs/toolkit";

import { AppState } from "@/redux/store/store";
import { fetchQuestions } from "@/models";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

export const fetchPlacesSurveyQuestions = createAsyncThunk(
  "places/fetchPlacesSurveyQuestions",
  async (
    params: Partial<{ projectId: string; placesId: string; config: object }>,
    { rejectWithValue, getState }
  ) => {
    const { adapter } = getState() as AppState;
    const { token } = fetchAuthToken(getState());

    const { baseUrl } = adapter.adapter;
    const { projectId, placesId, config } = params;

    const data = [];
    try {
      const response = await fetchQuestions(
        token,
        baseUrl,
        projectId,
        placesId,
        {},
        config
      );

      response.forEach((question) => {
        if (!question.deleted) {
          if (question.questionOptions) {
            question.questionOptions = question.questionOptions.filter(
              (option) => !option.deleted
            );
          }
          data.push(question);
        }
      });

      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
